import React, { useState } from 'react';
import css from './SectionVesselSpecs.module.css';

const INITIAL_COUNT = 3;

const FUEL_POLICY_LABELS = {
  'fuel-included': 'Fuel included',
  'first-tank-included': 'First tank included',
  'return-same-level': 'Return with same fuel level',
  'customer-pays-actual': 'Customer pays fuel cost',
};

// Fields excluded from vessel specs by label — catches fields whose config key
// doesn't match the key-based hidden list in CustomListingFields.
const EXCLUDED_LABELS = new Set([
  'Booking Window',
  'Availability End Date',
  'Fuel Policy',
  'Minimum Renter Age',
  'Minimum Participant Age',
  'Damage Deposit',
  'Cancellation Policy',
]);

const SectionVesselSpecs = ({ fields, fuelPolicy }) => {
  const [showAll, setShowAll] = useState(false);

  const filteredFields = (fields || []).filter(f => !EXCLUDED_LABELS.has(f.label));
  const fuelLabel = fuelPolicy ? FUEL_POLICY_LABELS[fuelPolicy] : null;

  if (filteredFields.length === 0 && !fuelLabel) return null;

  const visible = showAll ? filteredFields : filteredFields.slice(0, INITIAL_COUNT);
  const hasMore = filteredFields.length > INITIAL_COUNT;

  return (
    <section className={css.root}>
      <h2 className={css.heading}>Specifications</h2>
      <ul className={css.details}>
        {visible.map(field => (
          <li key={field.key} className={css.detailsRow}>
            <span className={css.detailLabel}>{field.label}</span>
            <span className={css.detailValue}>{field.value}</span>
          </li>
        ))}
        {(!hasMore || showAll) && fuelLabel ? (
          <li key="fuel_policy" className={css.detailsRow}>
            <span className={css.detailLabel}>Fuel Policy</span>
            <span className={css.detailValue}>{fuelLabel}</span>
          </li>
        ) : null}
      </ul>
      {hasMore ? (
        <button type="button" className={css.showAllBtn} onClick={() => setShowAll(s => !s)}>
          {showAll ? 'Show less' : 'Show all specifications'}
        </button>
      ) : null}
    </section>
  );
};

export default SectionVesselSpecs;
